import axios from "axios";
import "../styles/MenuPageStyles/menuStyle.css";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import config from "../config";
import Footer from "../components/Footer";
import { Card, Collapse, Nav, NavItem, NavLink, Row } from "reactstrap";
import classnames from "classnames";
import addImg from "../assets/MenuPage/addImg.jpg";
import swal from "sweetalert";
import ReactPaginate from "react-paginate";
import rollzMenu from "../assets/MenuCard.pdf";
import Loader from "../utils/Loader";
import { Helmet } from "react-helmet";

const MenuPage = () => {
  const location = useLocation();
  const [isLoading, setLoading] = useState(false);
  const [data, setdata] = useState([]);
  const [allData, setAllData] = useState([]);
  const [menuOffer, setMenuOffer] = useState("");
  const [introTitle, setIntroTitle] = useState("");
  const [introDesc, setIntroDesc] = useState("");

  const [showCat, setShowCat] = useState(false);
  const [activeCategory, setActiveCategory] = useState("1");
  const [activeSubcategory, setActiveSubcategory] = useState("1-1");
  const [isSubNavOpen, setIsSubNavOpen] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [offerImg, setOfferImg] = useState("");

  const { category_name } = useParams();

  useEffect(() => {
    onMenuCategory();
  }, []);

  useEffect(() => {
    setActiveCategory("1");
  }, [activeCategory]);


  const onMenuCategory = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("location", localStorage.getItem("location") || 1);
    try {
      const res = await axios({
        method: "post",
        url: `${config.apiUrl}/product_category`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        setLoading(false);
        setCategoryList(res.data.data);
        setOfferImg(res.data.menu_offers?.image);
        setIntroTitle(res.data.menu_offers?.title);
        setIntroDesc(res.data.menu_offers?.description);
        // console.log("Ajax Menu Category", res.data.data);
      });
    } catch (error) {
      setLoading(false);
      console.log("product category", error);
    }
  };

  const navigate = useNavigate();

  useEffect(() => {
    if (category_name && allData.length) {
      const Rollz = allData.filter((res) => res.menu_slug === category_name);
      setdata(Rollz);
    }
  }, [allData, category_name]);

  const [person_name, setPersonName] = useState("");
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({
    person_name_error: "",
    email_error: "",
  });

  const validateEmail = () => {
    let newError = {};
    // Check if the person_name is empty
    if (person_name === "") {
      newError.person_name_error = "Please Enter Name"; // Fixed from "newError ==" to "newError ="
    }

    // Check if the email is empty
    if (email === "") {
      newError.email_error = "Email is Required";
    } else if (!email || !/\S+@\S+\.\S+/.test(email)) {
      newError.email_error = "Please enter a valid email address";
    }

    // Set the error state if there's an error
    setErrors(newError);
    return Object.keys(newError).length === 0;
  };




  // Download Menu
  const onLocationMenu = async (e) => {
    e.preventDefault();

    if (validateEmail()) {
      setLoading(true);
      const formData = new FormData();
      formData.append("person_name", person_name);
      formData.append("customer_email", email);
      formData.append("location", localStorage.getItem("location") || 1);
      formData.append(
        "location_name",
        localStorage.getItem("location_name") || "Ajax"
      );
      formData.append("type", 0);

      try {
        const response = await axios({
          method: "post",
          url: `${config.apiUrl}/download_menu`,
          data: formData,
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        }).then((response) => {
          setLoading(false);
          swal({
            icon: "success",
            text: "Menu is sent to your email successfully",
          }).then((data) => {
            setEmail("");
            setPersonName("");
            // remove download feature
            // const anchor = document.createElement("a");
            // const fileUrl = rollzMenu;
            // anchor.href = fileUrl;

            // anchor.download = "MenuCard.pdf";
            // document.body.appendChild(anchor);
            // anchor.click();
            // document.body.removeChild(anchor);
          });
        });
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    }
  };

  // console.log("activeCategory", activeCategory);
  // console.log("Menu categotylist ", categoryList);
  return (
    <>
      <Helmet>
        <title>
          Best Halal Ice Cream Shop Near Me in Toronto | Rollz Ice Cream
        </title>
        <meta
          name="description"
          // content={metadata[location][menu]?.description}
          content="Download the Rollz Ice Cream menu for Halifax, Peterborough, Brantford, Brampton, Kitchener, Windsor, Vaughan, Guelph, Regina and for many more locations in Canada."
        />
        <meta
          property="og:title"
          content="Best Halal Ice Cream Shop Near Me in Toronto | Rollz Ice Cream"
        />
        <meta
          property="og:description"
          content="Download the Rollz Ice Cream menu for Halifax, Peterborough, Brantford, Brampton, Kitchener, Windsor, Vaughan, Guelph, Regina and for many more locations in Canada."
        />
      </Helmet>
      {isLoading && <Loader />}
      <div className="menu_page">
        <section className="menu_section">
          <div className="menuPage_container">
            <div className="container menuPage_wrapper">
              <div className="flex-column flex-md-row menu_container">
                {/* <Card className="col-12 col-md-3 col-sm-12 d-flex flex-column justify-content-start menu_category">
                  <h5 className="d-flex align-content-center justify-content-between text-white">
                    Categories
                    <span
                      className="d-block d-md-none"
                      onClick={() => setShowCat(!showCat)}
                    >
                      <i className="bi bi-list"></i>
                    </span>
                  </h5>
                  <Nav
                    pills
                    className={`d-flex menuPage_items flex-column justify-content-start my-3 d-md-block ${
                      showCat ? "d-md-block" : "d-none"
                    }`}
                  >
                    {categoryList?.map((category) => {
                      if (category.is_active == 1) {
                        return (
                          <NavItem key={category.id}>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={`d-flex justify-content-between align-items-center ${
                                category?.slug === category_name ? "active" : ""
                              }`}
                              onClick={() => {
                                navigate(
                                  `${config.appUrl}/menu/${category?.slug}`
                                );
                                setShowCat(false);
                              }}
                            >
                              {category.menu_name}
                              {category.subcategories?.length > 0 && (
                                <span style={{ marginLeft: "auto" }}>
                                  {activeCategory === category.id ? (
                                    <i className="bi bi-dash-lg ms-2"></i>
                                  ) : (
                                    <i className="bi bi-plus-lg ms-2"></i>
                                  )}
                                </span>
                              )}
                            </NavLink>
                            {activeCategory === category.id &&
                              category.subcategories && (
                                <Collapse
                                  isOpen={activeCategory === category.id}
                                >
                                  <Nav className="d-flex flex-column mx-3 my-2 subCategory">
                                    {category.subcategories.map((sub) => (
                                      <NavItem key={sub.id}>
                                        <NavLink
                                          style={{ cursor: "pointer" }}
                                          className={classnames({
                                            active:
                                              activeSubcategory === sub.id,
                                          })}
                                          onClick={() => {
                                            setActiveSubcategory(sub.id);
                                            setdata(
                                              allData.filter(
                                                (item) =>
                                                  item.menu_id === sub.id
                                              )
                                            );
                                          }}
                                        >
                                          {sub.name}
                                        </NavLink>
                                      </NavItem>
                                    ))}
                                  </Nav>
                                </Collapse>
                              )}
                          </NavItem>
                        );
                      }
                    })}
                  </Nav>
                </Card> */}
                <div className="col-12  col-sm-12 d-flex flex-column">
                  <div className="menu_add">

                    <img
                      src={offerImg}
                      className="img-fluid"
                      alt="advertising"
                      loading="lazy"
                      style={{
                        width: "100%",
                        height: "200px",
                        objectFit: "fill",
                      }}
                    />
                  </div>
                  <div className="col-12 d-flex flex-column align-items-start menuPage_products">
                    <Row className="col-12 products_container mt-4">
                      {categoryList
                        .filter((obj) => obj.subcategory !== 1)
                        .map((product, index) => (
                          <Link
                            key={index}
                            to={`${config.appUrl}/${localStorage.getItem('location_name')?.toLowerCase()?.replaceAll(",","")?.replaceAll(" ","-")}/${product?.slug}`}
                            className="col-12 col-md-3 col-sm-4 menu_card px-0 px-sm-2 py-2"
                          >
                            <div className="d-flex flex-column align-items-center justify-content-center single_product">
                              <div className="single_product_img">
                                <img
                                  src={product.url}
                                  alt="product_img"
                                  className="img-fluid"
                                  loading="lazy"
                                />
                              </div>
                              <div className="my-2 single_product_detail">
                                <h6 className="text-center py-2">
                                  {product.menu_name}
                                </h6>
                              </div>
                            </div>
                          </Link>
                        ))}
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Conatc form  */}
        <section className="menuPage_contact">
          <div className="container menuContact">
            <div className="text-center getmenu_heading mb-4">
              <h3>Get Our Menu </h3>
            </div>
            <form onSubmit={onLocationMenu}>
              <div className="d-flex flex-column flex-md-row flex-wrap row-gap-3 align-items-center justify-content-center gap-3">
                <div className="col-12 col-md-4 col-sm-10">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Name"
                    value={person_name}
                    // required
                    onChange={(e) => setPersonName(e.target.value)}
                  ></input>
                  {errors.person_name_error && (
                    <span className="bg-white text-danger error fw-bold ms-0 px-2 py-1">
                      <i className="bi bi-exclamation-circle-fill me-1"></i>
                      {errors.person_name_error}
                    </span>
                  )}
                </div>
                <div className="col-12 col-md-4 col-sm-10 d-fle flex-column gap-2">
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Enter Email"
                    value={email}
                    // required
                    onChange={(e) => setEmail(e.target.value)}
                  ></input>
                  {errors.email_error && (
                    <span className="bg-white text-danger error fw-bold ms-0 px-2 py-1">
                      <i className="bi bi-exclamation-circle-fill me-1"></i>
                      {errors.email_error}
                    </span>
                  )}
                </div>
                <div className="col-12 col-md-3 col-sm-10">
                  <div className="order-online">
                    <button className="blue-btn hero-anchor" type="submit">
                      <div className="order-online-trans-1"></div>
                      <div className="order-online-trans-2"></div>
                      Get Menu
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </section>

        <section className="menuPage_para_container">
          <div className="container">
            <div className="menuPage_para">
              <h2>{introTitle}</h2>

              <p>{introDesc}</p>
            </div>
          </div>
        </section>

        {/* <Footer color="#ffecf0" /> */}
      </div>
    </>
  );
};

export default MenuPage;
